import { Controller } from "@hotwired/stimulus"

// Generic bulk row selection (#10212): a header
// "select all" checkbox, a live selected count on the submit button, and a
// submit that stays disabled until at least one row is checked. Selection is
// per-page. Used by Admin > Merch Requests.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "submit", "count"]

  connect() {
    this.update()
  }

  toggleAll() {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = this.selectAllTarget.checked
    })
    this.update()
  }

  update() {
    const checkboxes = this.checkboxTargets
    const selected = checkboxes.filter((cb) => cb.checked).length

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = selected === 0
      this.syncDisabledReason(selected === 0)
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = selected > 0 ? ` ${selected}` : ""
    }
    if (this.hasSelectAllTarget) {
      const total = checkboxes.length
      this.selectAllTarget.checked = selected > 0 && selected === total
      this.selectAllTarget.indeterminate = selected > 0 && selected < total
    }
  }

  // A disabled control must explain why (design standard: "disabled buttons
  // explain why through the tooltip"). The caller supplies the sentence via
  // data-disabled-reason; we mirror it into the gl tooltip + accessible name
  // ONLY while disabled, then strip both so an enabled button falls back to its
  // own visible label instead of advertising a condition that no longer holds.
  // Opt-in: buttons without data-disabled-reason are left exactly as they were.
  syncDisabledReason(disabled) {
    const reason = this.submitTarget.dataset.disabledReason
    if (!reason) return

    if (disabled) {
      this.submitTarget.setAttribute("data-gl-tooltip", reason)
      this.submitTarget.setAttribute("aria-label", reason)
    } else {
      this.submitTarget.removeAttribute("data-gl-tooltip")
      this.submitTarget.removeAttribute("aria-label")
    }
  }
}
